export default "__VITE_ASSET__IpSzLtd7__"